import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Recipe } from '../entities/recipe';
import { Capsule } from '../../capsule/capsule';
import { RecipeWrapper } from '../entities/RecipeWrapper';
import { environment } from './../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RecipeService {

  apiUrl = environment.amplifyConfig.API.endpoints[0].endpointWithHttp;

  constructor(private http: HttpClient) {}

  getDefaultRecipes(token,from,size) {

    const  headers = new  HttpHeaders().set("authorization", "Bearer "+token);

    return this.http.get<RecipeWrapper[]>( this.apiUrl+'/user/recipe/default?from='+from+'&pageSize='+size+'&fields=name', {headers} );
    
  }

  getMachineDefaultRecipes(token) {

    const  headers = new  HttpHeaders().set("authorization", "Bearer "+token);

    return this.http.get<RecipeWrapper[]>( this.apiUrl+'/machine/recipe/default', {headers} );
    
  }

  getDefaultRecipeCount(token) {
    const  headers = new  HttpHeaders().set("authorization", "Bearer "+token);

    return this.http.get( this.apiUrl+'/user/recipe/default/count', {headers} );
  }

  getAllUserRecipeCount(token) {
    const  headers = new  HttpHeaders().set("authorization", "Bearer "+token);

    return this.http.get<Number>( this.apiUrl+'/user/recipe/all/count', {headers} );
  }

  addCoffeeRecipe(token, recipe:Recipe): Observable<Recipe> {
    const  headers = new  HttpHeaders().set("authorization", "Bearer "+token);

    return this.http.post<Recipe>( this.apiUrl+'/roaster/recipe/coffee', recipe, {headers} );
  }

  updateCoffeeRecipe(token, recipe:Recipe): Observable<Recipe> {
    const  headers = new  HttpHeaders().set("authorization", "Bearer "+token);

    return this.http.put<Recipe>( this.apiUrl+'/user/recipe/coffee/'+recipe.id, recipe, {headers} );
  }

  addDripBagRecipe(token, recipe:Recipe): Observable<Recipe> {
    const  headers = new  HttpHeaders().set("authorization", "Bearer "+token);

    return this.http.post<Recipe>( this.apiUrl+'/user/recipe/drip-bag', recipe, {headers} );
  }

  updateDripBagRecipe(token, recipe:Recipe): Observable<Recipe> {
    const  headers = new  HttpHeaders().set("authorization", "Bearer "+token);

    return this.http.put<Recipe>( this.apiUrl+'/user/recipe/drip-bag/'+recipe.id, recipe, {headers} );
  }

  addTeaRecipe(token, recipe:Recipe): Observable<Recipe> {
    const  headers = new  HttpHeaders().set("authorization", "Bearer "+token);

    return this.http.post<Recipe>( this.apiUrl+'/user/recipe/tea', recipe, {headers} );
  }

  updateTeaRecipe(token, recipe:Recipe): Observable<Recipe> {
    const  headers = new  HttpHeaders().set("authorization", "Bearer "+token);

    return this.http.put<Recipe>( this.apiUrl+'/user/recipe/tea/'+recipe.id, recipe, {headers} );
  }

  deleteDefaultRecipe(token, recipeId:number) {
    const  headers = new  HttpHeaders().set("authorization", "Bearer "+token);

    return this.http.delete( this.apiUrl+'/roaster/recipe/'+recipeId, {headers} );
  }

  updateRecipe(token, recipe:Recipe, isCustom:boolean) : Observable<Recipe> {
    const  headers = new  HttpHeaders().set("authorization", "Bearer "+token);

    return this.http.put<Recipe>( this.apiUrl+'/user/recipe/coffee/'+recipe.id, recipe, {headers} );
  }

  getCapsules(token) {

    const  headers = new  HttpHeaders().set("authorization", "Bearer "+token);

    return this.http.get<Capsule[]>( this.apiUrl+'/capsule?fields=name&pageSize=10&from=0&active=true', {headers} );
    
  }

  getRoasterRecipes(token,id,from,size) {

    const  headers = new  HttpHeaders().set("authorization", "Bearer "+token);

    return this.http.get<RecipeWrapper[]>( this.apiUrl+'/roaster/'+id+'/recipe?from='+from+'&pageSize='+size+'&fields=name', {headers} );
    
  }

  searchRoasterRecipes(token,id,from,size,search: String) {

    const  headers = new  HttpHeaders().set("authorization", "Bearer "+token);

    return this.http.get<RecipeWrapper[]>( this.apiUrl+'/roaster/'+id+'/recipe?from='+from+'&pageSize='+size+'&fields=name&search='+search, {headers} );
    
  }

  deleteRoasterRecipe(token, recipeId:number) {
    const  headers = new  HttpHeaders().set("authorization", "Bearer "+token);

    return this.http.delete( this.apiUrl+'/roaster/recipe/'+recipeId, {headers} );
  }

  updateRoasterCoffeeRecipe(token, recipe:Recipe): Observable<Recipe> {
    const  headers = new  HttpHeaders().set("authorization", "Bearer "+token);

    return this.http.put<Recipe>( this.apiUrl+'/roaster/recipe/coffee/'+recipe.id, recipe, {headers} );
  }

}
